import { Controller } from "@hotwired/stimulus";
import {
  get,
  parseRequestOptionsFromJSON,
} from "@github/webauthn-json/browser-ponyfill";
import { jsonHeaders } from "./passkey_csrf";

// Connects to data-controller="passkey-conditional"
// Values: optionsUrl, callbackUrl
// Pairs with an <input autocomplete="username webauthn"> on the page.
export default class extends Controller {
  static values = { optionsUrl: String, callbackUrl: String };

  async connect() {
    this.onManualStart = () => this.abort?.abort();
    window.addEventListener("passkey:manual-start", this.onManualStart);

    if (!(await this.available())) return;

    this.abort = new AbortController();

    try {
      const res = await fetch(this.optionsUrlValue, {
        method: "POST",
        headers: jsonHeaders(),
        credentials: "same-origin",
        body: "{}",
      });
      if (!res.ok) return;
      const { options, ceremony_id } = await res.json();

      const credential = await get({
        ...parseRequestOptionsFromJSON({ publicKey: options }),
        mediation: "conditional",
        signal: this.abort.signal,
      });

      const cb = await fetch(this.callbackUrlValue, {
        method: "POST",
        headers: jsonHeaders(),
        credentials: "same-origin",
        body: JSON.stringify({ publicKeyCredential: credential, ceremony_id }),
      });
      const data = await cb.json().catch(() => ({}));
      if (cb.ok && data.redirect_to) Turbo.visit(data.redirect_to);
    } catch (_err) {
      // Autofill cancelled / aborted / no credential — silent by design.
    }
  }

  disconnect() {
    window.removeEventListener("passkey:manual-start", this.onManualStart);
    this.abort?.abort();
  }

  async available() {
    return (
      window.PublicKeyCredential &&
      typeof PublicKeyCredential.isConditionalMediationAvailable ===
        "function" &&
      (await PublicKeyCredential.isConditionalMediationAvailable())
    );
  }
}
